<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
  },
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    async onExport() {
      this.$loading.active = true
      const cvs = await this.fetchCVsIndependent({
        adminQueryType: 'g10ExamTrial',
        fromAdmin: true,
        _start: 0,
        _limit: -1,
      })
      const isUserAdminBoth = this.$helpers.ALLOWED_VIEW_DETAIL_TRANS_SCHOLARSHIP.includes(this.user.id)
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => {
          const res = {
            'Mã hồ sơ': cv.code,
            'Cơ sở': cv.department,
            'Họ tên học sinh': cv.name,
            'Số điện thoại đăng ký': cv.parentUsername,
            Email: cv.parentEmail,
            'Kỳ thi đăng ký': get(cv, 'g10ExamTransactionData', []).join(','),
          }
          if (isUserAdminBoth) {
            const transResult = this.renderTransDetail(cv)
            res['Mã tài khoản nhận tiền - Mã tham chiếu giao dịch - Kỳ thi đăng ký (ngăn cách các lần bằng ";")'] = transResult
          }
          return res
        })
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ho-so-k10-dangkythithu.xlsx')
      this.$loading.active = false
    },
    renderTransDetail(cv) {
      const trans = get(cv, 'g10ExamTransactions', [])
      if (Array.isArray(trans) && trans.length) {
        return trans
          .map(t => {
            const code = get(t, 'code', '')
            const transId = get(t, 'transactionId', '')
            const data = get(t, 'data', [])
            return [`9LTV${code}`, transId, data.join(',')].join(' | ')
          })
          .join(';\n')
      }
      return ''
    },
  },
}
</script>
